import { DESKTOP_MIN_WIDTH } from 'constants';
import React from 'react';
import styled from 'styled-components';

const FormControlFeedback = ({ value = '', styles = {} }) => {
  if (!value) return null;
  return (
    <FormControlFeedbackStyled hidden={false} type="invalid" style={styles}>
      {value}
    </FormControlFeedbackStyled>
  );
};

const FormControlFeedbackStyled = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: var(--ds-c-red);
  position: absolute;
  margin-top: 4px;
  margin-bottom: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

export default FormControlFeedback;
